module.exports = __webpack_public_path__ + "static/ec-orr-mobile-73337581c07e79693a91a9c02550b0df.png";